import { FieldTypeOperator } from 'common/filter/models/AudienceFilter/constants'

export const OPERATOR_VIEW_ALIASES: Partial<Record<FieldTypeOperator, FieldTypeOperator>> = {
  [FieldTypeOperator.IN]: FieldTypeOperator.IS,
  [FieldTypeOperator.NOT_IN]: FieldTypeOperator.IS_NOT,
}
